<template>
  <div class="chart-common-options-setting-dialog">
    <!-- 位置尺寸旋转 -->
    <div v-if="options.chartOption" class="content-group-default colorfff6">
      <div class="setting-item">
        <div class="content">
          <el-collapse v-model="activeNames">
            <!-- 网格线设置 -->
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
              title="网格线"
              name="1"
              v-if="
                hasProperty(options, 'chartOption.yAxis.splitLine') ||
                hasProperty(options, 'chartOption.xAxis.splitLine')
              "
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '1')"
              >
                <splitLineXSetting :options="options" :ids="ids" :doubleYAxis="yAxisTwo" />
              </div>
            </el-collapse-item>
            <!-- 提示框设置 -->
            <el-collapse-item
              v-if="hasProperty(options, 'chartOption.tooltip')"
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
              title="提示框"
              name="2"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '2')"
              >
                <tooltipSetting :options="options" :ids="ids" />
              </div>
            </el-collapse-item>
            <!-- X轴设置 -->
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
              title="横轴设置"
              name="3"
              v-if="hasProperty(options, 'chartOption.xAxis') || hasProperty(options, 'chartOption.radiusAxis')"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '3')"
              >
                <XAxisSetting v-if="axisType === 'rectangular'" :options="options" :ids="ids" />
                <RadiusAxisSetting v-else :options="options" :ids="ids" />
              </div>
            </el-collapse-item>
            <!-- Y轴设置 -->
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
              title="纵轴设置"
              name="4"
              v-if="(hasProperty(options, 'chartOption.yAxis') || hasProperty(options, 'chartOption.angleAxis')) && !yAxisTwo"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '4')"
              >
                <YAxisSetting v-if="axisType === 'rectangular'" :options="options" :ids="ids" />
                <AngleAxisSetting v-else :options="options" :ids="ids" />
                <cx-select
                  class="mt16"
                  title="文字对齐方式"
                  :selectOptions="textAlignOrient"
                  :value.sync="yAxisTextAlign"
                  v-show="showYAxisTextAlign"
                />
              </div>
            </el-collapse-item>
            <!-- Y轴设置 -->
            <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '9')"
                title="双纵轴设置"
                name="9"
                v-if="yAxisTwo"
            >
              <div
                  class="setting-item"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '9')"
              >
                <doubleYAxisSetting v-if="axisType === 'rectangular'" :options="options" :ids="ids" />
              </div>
            </el-collapse-item>
            <!-- 边距设置 -->
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
              title="边距"
              name="5"
              v-if="hasProperty(options, 'chartOption.grid')"
            >
              <div
                class="setting-item setting-item-grid"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '5')"
              >
                <gridSetting :options="options" :ids="ids" />
              </div>
            </el-collapse-item>
            <!-- 动画设置 -->
            <el-collapse-item
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
              title="图表动画"
              name="6"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '6')"
              >
                <animationSetting :options="options" :ids="ids" />

              </div>
            </el-collapse-item>
            <el-collapse-item
              v-show="$store.state.states.showPluginSetting"
              @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
              title="插件"
              name="7"
            >
              <div
                class="setting-item"
                v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '7')"
              >
                <div class="right_font"><span @click="addPlugin" class="icon-portal-plus-small plugin_title"></span></div>
                <div v-for="(item, index) in pluginName" :key="index" class="mt8 plugins">
                  <span class="plugin_title mr8">插件名</span>
                  <el-input
                    class="mr8"
                    style="width: 154px"
                    :value="item"
                    @input="changePluginName(index, $event)"
                    placeholder="请输入插件名"
                  ></el-input>
                  <span @click="delPlugin(index)" class="plugin_title icon-portal-delete"></span>
                </div>
              </div>
            </el-collapse-item>
            <!-- 外观 -->
            <el-collapse-item
                @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '8')"
                title="外观"
                name="8">
              <div
                  class="setting-item setting-item-grid"
                  v-if="collapseActiveNames.length !== 0 && collapseActiveNames.find(it => it === '8')"
              >
                <slider-and-input
                    inputWidth="small"
                    inputHeight="small"
                    :value.sync="opacity"
                    title="透明度"
                    :sliderMax="100"
                    suffix="%"
                />
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import XAxisSetting from "./options/XAxisSetting.vue"
import YAxisSetting from "./options/YAxisSetting.vue"
import RadiusAxisSetting from "./options/RadiusAxisSetting.vue"
import AngleAxisSetting from "./options/AngleAxisSetting.vue"
import splitLineXSetting from "./options/splitLineXSetting.vue"
import tooltipSetting from "./options/tooltipSetting.vue"
import gridSetting from "./options/gridSetting.vue"
import animationSetting from "./options/animationSetting.vue"
import doubleYAxisSetting from "./options/doubleYAxisSetting.vue"
export default {
  name: "chart-common-options-setting",
  components: {
    XAxisSetting,
    YAxisSetting,
    RadiusAxisSetting,
    AngleAxisSetting,
    splitLineXSetting,
    animationSetting,
    gridSetting,
    tooltipSetting,
    doubleYAxisSetting
  },
  props: {
    ids: null,
    options: Object,
    initCollapse: {
      type: Boolean | Array,
      default: true
    }
  },
  data() {
    return {
      baseCollapse: ["1", "2"],
      activeNames: [],
      allCollapseNames: ["3", "4", "5", "6", "7", "8", "9"],
      collapseActiveNames: [],
      textAlignOrient: [
        { label: "居左", value: "left" },
        { label: "居中", value: "center" },
        { label: "居右", value: "right" }
      ]
    }
  },

  computed: {
    chartType: {
      get() {
        return this.options.type
      }
    },
    pluginName: {
      get() {
        return this.options.chartOption.pluginName
      },
      set(val) {
        this.$changeOptionsEV(val, "chartOption.pluginName", false)
      }
    },
    axisType: {
      get() {
        return this.options.chartOption.seriesTempAttributes
          ? this.options.chartOption.seriesTempAttributes.coordinateType
          : null
      }
    },
    showYAxisTextAlign: {
      get() {
        if (
          this.options.chartOption.yAxis != undefined &&
          this.options.chartOption.yAxis.data != undefined &&
          this.options.chartOption.yAxis.data.length > 0 &&
          this.options.chartOption.yAxis.axisLabel.rich == undefined
        ) {
          return true
        } else {
          return false
        }
      }
    },
    yAxisTextAlign: {
      get() {
        if (
          this.options.chartOption.yAxis != undefined &&
          this.options.chartOption.yAxis.data != undefined &&
          this.options.chartOption.yAxis.data.length > 0 &&
          this.options.chartOption.yAxis.axisLabel.rich == undefined
        ) {
          return this.checkAndSetPrimaryVal(this.options.chartOption.yAxis.data[0].textStyle, "align", "align", "left")
        } else {
          return null
        }
      },
      set(val) {
        if (
          this.options.chartOption.yAxis != undefined &&
          this.options.chartOption.yAxis.data != undefined &&
          this.options.chartOption.yAxis.data.length > 0 &&
          this.options.chartOption.yAxis.axisLabel.rich == undefined
        ) {
          let newYAxisData = this.options.chartOption.yAxis.data
          for (let i = 0; i < this.options.chartOption.yAxis.data.length; i++) {
            newYAxisData[i].textStyle.align = val
          }
          this.$changeOptionsEV(newYAxisData, "chartOption.yAxis.data", false)
        }
      }
    },
    opacity: {
      get() {
        return this.checkAndSetPrimaryVal(this.options, "opacity", "opacity", 100)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "opacity", false)
      }
    },
    yAxisTwo() {
      if(this.options.chartOption.yAxis?.length && this.options.chartOption.yAxis?.length === 2){
        return true
      }else {
        return false
      }
    }
  },
  methods: {
    changePluginName(index, name) {
      this.$changeOptionsEV(name, "chartOption.pluginName." + index, false)
    },
    delPlugin(index) {
      const pluginName = [...this.pluginName]
      pluginName.splice(index, 1)
      this.$changeOptionsEV(pluginName, "chartOption.pluginName", false)
    },
    addPlugin() {
      this.$changeOptionsEV("", "chartOption.pluginName." + this.pluginName.length, false)
    },
    initBaseCollapse() {
      if (typeof this.initCollapse === "boolean") {
        this.activeNames.push(...this.baseCollapse)
        this.collapseActiveNames.push(...this.baseCollapse)
      } else {
        this.allCollapseNames.unshift(...this.initCollapse)
      }
    }
  },
  created() {
    this.initBaseCollapse()
  },
  mounted() {
    this.$collapseControl({
      allCollapseNames: this.allCollapseNames,
      collapseActiveNames: this.collapseActiveNames,
      activeNames: this.activeNames
    })
  }
}
</script>

<style scoped>
.right_font {
  text-align: right;
}
.plugin_title {
  display: inline-block;
}
.plugin_title:hover {
  cursor: pointer;
}
.plugins {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>
